import firebase from "datastore/database";
import store from "datastore/store";

import { fbTsToDate } from "common/date";

import { add, deleteF, get, update } from "../generalCRUD";

const getCollectionUrl = (uid) => `forms/business/${uid}`;
const getCompletedFormsUrl = (uid) => `completed-forms/business/${uid}`;

export async function updateForm(businessUid, uid, data) {
  const url = getCollectionUrl(businessUid);
  return update(uid, data, url);
}

export function addForm(businessUid, data) {
  const url = getCollectionUrl(businessUid);
  return add(data, url);
}

export function addCompletedForm(businessUid, data) {
  const url = getCompletedFormsUrl(businessUid);
  return add(data, url);
}

export async function deleteForm(businessUid, uid) {
  const url = getCollectionUrl(businessUid);
  return deleteF(uid, url);
}

export function observeForms(businessUid) {
  const path = getCollectionUrl(businessUid);
  return firebase
    .firestore()
    .collection(path)
    .onSnapshot((snapshot) => {
      const forms = snapshot.docs.map((doc) => ({
        ...doc.data(),
        uid: doc.id,
        added: fbTsToDate(doc.data()?.added ?? new Date()),
        deleteButton: true,
      }));
      store.dispatch({ type: "ADD_FORMS_SUCCESS", forms });
    });
}

export function observeCompletedForms(businessUid) {
  store.dispatch({ type: "ADD_COMPLETED_FORMS_LOADING" });
  const path = getCompletedFormsUrl(businessUid);
  const forms = store.getState().forms.data;

  if (forms.length === 0) {
    return;
  }
  return firebase
    .firestore()
    .collection(path)
    .onSnapshot((snapshot) => {
      const completedForms = snapshot.docs.map((doc) => {
        const formData = doc.data();
        const formUid = formData.formUid;
        const form = forms.find((f) => f.uid === formUid);
        const formName = form ? form.name : "Unknown Form";
        const customerName = formData?.name ?? "Unknown Customer";
        const target = formData?.target ?? formData?.type;

        return {
          ...formData,
          uid: doc.id,
          createdAt: fbTsToDate(formData?.createdAt),
          formName,
          customerName,
          formElements: form?.form,
          target,
        };
      });
      completedForms.sort((a, b) => b.createdAt - a.createdAt);
      store.dispatch({ type: "ADD_COMPLETED_FORMS_SUCCESS", completedForms });
    });
}

export async function getFormResponse(businessUid, uid) {
  const completedForms = store.getState().completedForms.data;
  const form = completedForms?.find((f) => f.uid === uid);

  if (form) {
    return form;
  } else {
    const url = getCompletedFormsUrl(businessUid);
    const formResponse = await get(uid, url);
    if (!formResponse) {
      return null;
    }
    return formResponse;
  }
}
